import script from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"

import "./UserProfile.vue?vue&type=style&index=0&id=64cb7f94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64cb7f94"]])

export default __exports__